<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolStudentInformationSystemSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/student-information-system/student-profile",
                title: "Student Profile",
                description: "View and update student records and personal details.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Guardian Information",
                description: "Manage guardian contact details linked to students.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/student-information-system/student-promotion",
                title: "Student Promotion",
                description: "Promote students and update their class placements.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/student-information-system/alumni-management",
                title: "Alumni Management",
                description: "Maintain records and connections for former students.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
